import React from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import wizardsShape from 'core/components/wizard/shapes'
import { List, Row, Col } from 'core/components/ui'
//import { FormattedMessage } from 'react-intl'

import _ from 'lodash'
import styled from 'styled-components'
import * as routes from 'core/routing/constants/index'
import PriceFrom, { SIZE as PriceFromSIZE } from 'core/layouts/price-from'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { greys, font } from 'assets/themes/theme-default'
import { configuratorShape, finishesShape } from '../../shapes'

const Icon = styled(SVG)`
  width: 25px;

  margin-right: 10px;
`

const StyledListItem = styled(List.Item)`
  padding: 0;
  margin-right: 10px;
`

const StyledRow = styled(Row)`
  margin: 0 0 0px 0;
  min-height: 80px;
  padding: 10px 0;
  line-height: normal;
  color: ${props => (props.selected ? greys.light4 : greys.dark1)};
  font-weight: ${font.weight.bold};
  box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
  background: ${props => (props.selected ? props.theme.colors.color1.bg : greys.light4)};
  ${Icon} {
    fill: ${props => (props.selected ? greys.light4 : props.theme.colors.color1.bg)};
  }
`

const ListItem = props => {
  const {
    item,
    handleClickShowEquipment,
    configurator,
    setConfigurator,
    setWizards,
    wizards,
    history
  } = props

  const { finishes } = configurator

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FINISHES) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const desactivateNextSteps = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const currentIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FINISHES)

    const steps = aStepsActive.map((step, index) => {
      let returnedStep = step
      if (index > currentIndex) returnedStep = { ...step, isActive: false }

      return returnedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: steps }

    setWizards(extentedWizards)
  }

  const handleOnChangeSelection = async () => {
    const motor = _.isEqual(item, configurator.finishes) ? configurator.motor : null

    const motorsList = _.isEqual(item, configurator.finishes) ? configurator.motorsList : null
    if (!_.isEqual(item, configurator.finishes)) await desactivateNextSteps()

    const extentedConfigurator = {
      ...configurator,
      finishes: item,
      price: item.price,
      motorsList,
      motor
    }

    setConfigurator(extentedConfigurator)
    activateNextStep()
  }
  //selected={selected}
  return (
    <StyledListItem
      onClick={e => {
        e.preventDefault()
        handleOnChangeSelection()
      }}
    >
      <StyledRow
        type="flex"
        align="middle"
        gutter={50}
        selected={!finishes ? false : item.title === finishes.title}
      >
        <Col span={10}>{item.title}</Col>
        <Col span={4}>
          <Icon
            svg={svg.lightBulb}
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              handleClickShowEquipment(item.id)
            }}
          />
        </Col>
        <Col span={10}>
          <PriceFrom value={item.price} size={PriceFromSIZE.sm} />
        </Col>
      </StyledRow>
    </StyledListItem>
  )
}
//<Row>{item.items && item.items.map(el => <div key={el.title}>{el.title}</div>)}</Row>
ListItem.propTypes = {
  item: finishesShape.isRequired,
  handleClickShowEquipment: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  wizards: wizardsShape.isRequired,
  setWizards: PropTypes.func.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(ListItem)
